import interface_book from './interface-book.svg';
import interface_book_open from './interface-book-open.svg';
import interface_bookmark from './interface-bookmark.svg';
import interface_chart_bar_horizontal_01 from './interface-chart-bar-horizontal-01.svg';
import interface_chart_bar_vertical_01 from './interface-chart-bar-vertical-01.svg';
import interface_chart_line from './interface-chart-line.svg';
import interface_chart_pie from './interface-chart-pie.svg';
import interface_check from './interface-check.svg';
import interface_check_all from './interface-check-all.svg';
import interface_check_all_big from './interface-check-all-big.svg';
import interface_check_big from './interface-check-big.svg';
import interface_checkbox_check from './interface-checkbox-check.svg';
import interface_checkbox_fill from './interface-checkbox-fill.svg';
import interface_checkbox_unchecked from './interface-checkbox-unchecked.svg';
import interface_command from './interface-command.svg';
import interface_credit_card_01 from './interface-credit-card-01.svg';
import interface_credit_card_02 from './interface-credit-card-02.svg';
import interface_download from './interface-download.svg';
import interface_drag_horizontal from './interface-drag-horizontal.svg';
import interface_drag_vertical from './interface-drag-vertical.svg';
import interface_dummy_circle from './interface-dummy-circle.svg';
import interface_dummy_circle_circle from './interface-dummy-circle-circle.svg';
import interface_dummy_square from './interface-dummy-square.svg';
import interface_dummy_square_circle from './interface-dummy-square-circle.svg';
import interface_exit from './interface-exit.svg';
import interface_external_link from './interface-external-link.svg';
import interface_filter from './interface-filter.svg';
import interface_filter_off from './interface-filter-off.svg';
import interface_gift from './interface-gift.svg';
import interface_handbag from './interface-handbag.svg';
import interface_heart_01 from './interface-heart-01.svg';
import interface_heart_02 from './interface-heart-02.svg';
import interface_instance from './interface-instance.svg';
import interface_label from './interface-label.svg';
import interface_line_l from './interface-line-l.svg';
import interface_line_m from './interface-line-m.svg';
import interface_line_s from './interface-line-s.svg';
import interface_line_xl from './interface-line-xl.svg';
import interface_link from './interface-link.svg';
import interface_link_break from './interface-link-break.svg';
import interface_link_horizontal from './interface-link-horizontal.svg';
import interface_link_horizontal_off from './interface-link-horizontal-off.svg';
import interface_link_vertical from './interface-link-vertical.svg';
import interface_loading from './interface-loading.svg';
import interface_lock from './interface-lock.svg';
import interface_lock_open from './interface-lock-open.svg';
import interface_log_out from './interface-log-out.svg';
import interface_magnifying_glass_minus from './interface-magnifying-glass-minus.svg';
import interface_magnifying_glass_plus from './interface-magnifying-glass-plus.svg';
import interface_main_component from './interface-main-component.svg';
import interface_money_coin from './interface-money-coin.svg';
import interface_money_dollar from './interface-money-dollar.svg';
import interface_option from './interface-option.svg';
import interface_radio_fill from './interface-radio-fill.svg';
import interface_radio_unchecked from './interface-radio-unchecked.svg';
import interface_search_magnifying_glass from './interface-search-magnifying-glass.svg';
import interface_settings from './interface-settings.svg';
import interface_settings_future from './interface-settings-future.svg';
import interface_shopping_bag_01 from './interface-shopping-bag-01.svg';
import interface_shopping_bag_02 from './interface-shopping-bag-02.svg';
import interface_shopping_cart_01 from './interface-shopping-cart-01.svg';
import interface_shopping_cart_02 from './interface-shopping-cart-02.svg';
import interface_slider_01 from './interface-slider-01.svg';
import interface_slider_02 from './interface-slider-02.svg';
import interface_slider_03 from './interface-slider-03.svg';
import interface_star from './interface-star.svg';
import interface_suitcase from './interface-suitcase.svg';
import interface_switch_left from './interface-switch-left.svg';
import interface_switch_right from './interface-switch-right.svg';
import interface_tag from './interface-tag.svg';
import interface_ticket_voucher from './interface-ticket-voucher.svg';
import interface_trash_empty from './interface-trash-empty.svg';
import interface_trash_full from './interface-trash-full.svg';
import interface_trending_down from './interface-trending-down.svg';
import interface_trending_up from './interface-trending-up.svg';
import interface_upload_01 from './interface-upload-01.svg';
import interface_upload_02 from './interface-upload-02.svg';

export const V2_INTERFACE_ICONS: { [char: string]: string } = {
  interface_book,
  interface_book_open,
  interface_bookmark,
  interface_chart_bar_horizontal_01,
  interface_chart_bar_vertical_01,
  interface_chart_line,
  interface_chart_pie,
  interface_check,
  interface_check_all,
  interface_check_all_big,
  interface_check_big,
  interface_checkbox_check,
  interface_checkbox_fill,
  interface_checkbox_unchecked,
  interface_command,
  interface_credit_card_01,
  interface_credit_card_02,
  interface_download,
  interface_drag_horizontal,
  interface_drag_vertical,
  interface_dummy_circle,
  interface_dummy_circle_circle,
  interface_dummy_square,
  interface_dummy_square_circle,
  interface_exit,
  interface_external_link,
  interface_filter,
  interface_filter_off,
  interface_gift,
  interface_handbag,
  interface_heart_01,
  interface_heart_02,
  interface_instance,
  interface_label,
  interface_line_l,
  interface_line_m,
  interface_line_s,
  interface_line_xl,
  interface_link,
  interface_link_break,
  interface_link_horizontal,
  interface_link_horizontal_off,
  interface_link_vertical,
  interface_loading,
  interface_lock,
  interface_lock_open,
  interface_log_out,
  interface_magnifying_glass_minus,
  interface_magnifying_glass_plus,
  interface_main_component,
  interface_money_coin,
  interface_money_dollar,
  interface_option,
  interface_radio_fill,
  interface_radio_unchecked,
  interface_search_magnifying_glass,
  interface_settings,
  interface_settings_future,
  interface_shopping_bag_01,
  interface_shopping_bag_02,
  interface_shopping_cart_01,
  interface_shopping_cart_02,
  interface_slider_01,
  interface_slider_02,
  interface_slider_03,
  interface_star,
  interface_suitcase,
  interface_switch_left,
  interface_switch_right,
  interface_tag,
  interface_ticket_voucher,
  interface_trash_empty,
  interface_trash_full,
  interface_trending_down,
  interface_trending_up,
  interface_upload_01,
  interface_upload_02,
};

export const V2_INTERFACE_ICON_NAMES: string[] = Object.keys(V2_INTERFACE_ICONS);
